export default "/images/vendor/flag-icon-css/flags/1x1/sy.svg?ad05d8d10d2ef78fd2e2d2bc43a33bd6";